const variables = {
	variables: {
		breakPoint: 800, // When to toggle to mobile view
		wrapBreakPoint: 340, // On small devices wrap text to new line
		padding: 20,
		margin: 20,
	},
};

export default variables;
